export const ALGO_ACTION_TYPES = {
  SET_ALGORITHM: 'algo/SET_ALGORITHM',
  SET_IS_ALGO_DROPDOWN_OPEN: 'algo/SET_IS_ALGO_DROPDOWN_OPEN',
};

export const ALGO_TYPES = {
  BUBBLE: 'Bubble Sort',
  HEAP: 'Heap Sort',
  INSERTION: 'Insertion Sort',
  MERGE: 'Merge Sort',
  QUICK: 'Quick Sort',
  SELECTION: 'Selection Sort',
};
